import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Cancel from "@material-ui/icons/Cancel";
import InputAdornment from "@material-ui/core/InputAdornment";
import { useDebounce, OSSIcon } from "@oss/components";

const useStyles = makeStyles(theme => ({
  root: {
    background: "white",
    borderRadius: 25,
    height: theme.spacing(6)
  },
  clearIcon: {
    color: "#d5d5d5",
    cursor: "pointer",
    "&:hover": {
      color: "#9a9a9a"
    }
  }
}));

const OSSSearchBar = ({
  variant = "outlined",
  label = "Search",
  defaultSortOrder = "-created",
  query,
  setQuery,
  clearable = null,
  margin = "dense",
  fullWidth = null,
  inputClasses = null,
  ...rest
}) => {
  const classes = useStyles();
  const [search, setSearch] = useState("");
  const debouncedSearchTerm = useDebounce(search, 500);

  const handleChange = evt => {
    const { value } = evt.target;
    setSearch(value);
  };

  const firstUpdate = useRef(true);

  //monitor the query to see if the search string has changed
  // ie. clear all was clicked
  useEffect(() => {
    setSearch(query.search || "");
  }, [query.search]);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    if (debouncedSearchTerm) {
      setQuery({
        ...query,
        search: debouncedSearchTerm,
        ordering: "-relevance",
        offset: 0
      });
    } else {
      let sortOrder = defaultSortOrder;
      //if had a text search but ordered by something other than relevance, keep that
      if (query.ordering && !query.ordering.match(/relevance/)) {
        sortOrder = query.ordering;
      }

      delete query.search;
      setQuery({ ...query, ordering: sortOrder, offset: 0 });
    }
    // eslint-disable-next-line
  }, [debouncedSearchTerm]);

  const handleClear = () => {
    setSearch("");
  };

  return (
    <TextField
      placeholder={label}
      value={search}
      onChange={handleChange}
      variant={variant}
      fullWidth={fullWidth}
      margin={margin}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <OSSIcon name="search" />
          </InputAdornment>
        ),
        ...(clearable &&
          search &&
          search !== "" && {
            endAdornment: (
              <InputAdornment position="end">
                <Cancel className={classes.clearIcon} onClick={handleClear} />
              </InputAdornment>
            )
          }),
        classes: { root: classes.root, input: classes.input }
      }}
      {...rest}
    />
  );
};

export default OSSSearchBar;
